import type { Enums } from "@msuite/utils/types";
import type { IconName } from "../icons";

export function getAlertIconName(variant: Enums<"alertLevelType">): IconName {
	switch (variant) {
		case "success":
			return "Check";
		case "danger":
			return "X";
		case "warning":
			return "AlertTriangle";
		case "info":
			return "Info";
		case "neutral":
			return "HelpCircle";
		default:
			return "HelpCircle";
	}
}
